import bonusSvg from './assets/bonus.svg';
import discountSvg from './assets/discount.svg';
import mortgageSvg from './assets/mortgage.svg';
import { ELabelType } from '../../../../types/promosPage';

export const LABEL_BACKGROUNDS: Record<ELabelType, string> = {
  [ELabelType.Mortgage]: 'primary_10',
  [ELabelType.NewbuildingCount]: 'black_6',
  [ELabelType.Discount]: 'success_10',
  [ELabelType.Bonus]: '#ff7e001a',
  [ELabelType.Sale]: 'primary_100',
};

export const LABEL_COLORS: Record<ELabelType, string> = {
  [ELabelType.Mortgage]: 'primary_100',
  [ELabelType.NewbuildingCount]: 'black_100',
  [ELabelType.Discount]: 'success_100',
  [ELabelType.Bonus]: '#db6f0a',
  [ELabelType.Sale]: 'white_100',
};

export const LABEL_ICONS_MAP: Record<ELabelType, string> = {
  [ELabelType.Bonus]: bonusSvg,
  [ELabelType.Discount]: discountSvg,
  [ELabelType.Mortgage]: mortgageSvg,
  [ELabelType.NewbuildingCount]: '',
  [ELabelType.Sale]: '',
};
